import {Component, inject, Inject} from '@angular/core';
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogTitle} from "@angular/material/dialog";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {NgIf} from "@angular/common";
import {brand} from "../../../settings/humanum";
import {CommunicationCenterService} from "@modules/communication-center";
import {FreemiumPremiumService} from "shared/fremium-premium/freemium-premium.service";
import {EventService} from "shared/event.service";

@Component({
    selector: 'app-freemium-premium-modal',
    imports: [
        MatCardModule,
        MatButtonModule,
        MatDialogTitle,
        MatIcon,
        TranslateModule,
        NgIf
    ],
    templateUrl: './freemium-premium-modal.component.html',
    styleUrl: './freemium-premium-modal.component.scss'
})
export class FreemiumPremiumModalComponent {
    private matDialogRef: any;
    private communicationCenter = inject(CommunicationCenterService);
    private freemiumPremiumService = inject(FreemiumPremiumService);
    private eventService = inject(EventService);
    protected readonly brand = brand;

    constructor(@Inject(MAT_DIALOG_DATA) public data: { attemptedUrl: string }) {
    }

    /**
     * Vérifie si attemptedUrl contient une des clés de matchedUrls.
     * Retourne la valeur associée ou 'default' si aucune clé n'est trouvée.
     */
    public getMatchedUrlValue(): string {
        for (const key in this.freemiumPremiumService.matchedUrls) {
            if (this.data.attemptedUrl.includes(key)) {
                return this.freemiumPremiumService.matchedUrls[key];
            }
        }
        return 'default';
    }

    public get displayBtnFreemiumPremiumAccess(): boolean {
        return this.freemiumPremiumService.isFreemiumPremiumFeatureEnabled() && this.freemiumPremiumService.isFreemiumMode();
    }

    public openModalAccessPremium() {
        this.eventService.trackEvent('open modal', 'modal ' + this.data?.attemptedUrl, 'premium');
        this.communicationCenter
            .getRoom('freemium-premium')
            .getSubject('access-premium-display-compare-modal')
            .next(true);
    }

}